import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { faqContent } from '../../content';
import { homepageContent } from '../../data/products';
import './FAQ.css';

const FAQ = () => {
  const faqs = faqContent.faqs;
  const [openIndex, setOpenIndex] = useState(-1);
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.12 });

  const toggle = (index) => {
    setOpenIndex((current) => (current === index ? -1 : index));
  };

  if (!faqs.length) return null;

  return (
    <section id="faq" className="faq">
      <div ref={ref} className={`faq-inner ${inView ? 'visible' : ''}`}>
        <div className="faq-header">
          <span className="section-tag">{homepageContent.faq.eyebrow}</span>
          <h2 className="section-title">{homepageContent.faq.title}</h2>
        </div>

        <div className="faq-list">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q} className={`faq-item ${isOpen ? 'open' : ''}`}>
                <h3 className="faq-heading">
                  <button
                    type="button"
                    className="faq-question"
                    id={`faq-trigger-${index}`}
                    aria-expanded={isOpen}
                    aria-controls={`faq-panel-${index}`}
                    onClick={() => toggle(index)}
                  >
                    <span className="faq-question-text">{item.q}</span>
                    <svg
                      className="faq-chevron"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      aria-hidden="true"
                      focusable="false"
                    >
                      <path
                        d="M3 5.5 8 10.5 13 5.5"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </h3>
                <div
                  id={`faq-panel-${index}`}
                  className="faq-panel"
                  role="region"
                  aria-labelledby={`faq-trigger-${index}`}
                >
                  <div className="faq-panel-inner">
                    <p className="faq-answer">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
